import { useContext } from 'react'
import CMSContext from '../contexts/CMSContext'

function useCMSContext() {
  return useContext(CMSContext)
}

export default useCMSContext
